import { ApplicationEventsQuery } from "@graffer-inc/smart-apply";
import { matchType } from "../base/base-type";
import {
  ApplicationEventType,
  ContentModified,
  Created,
  InternalCommentAdded,
  IssueFilesAdded,
  IssueFilesCancelled,
  IssueFilesFirstDownloaded,
  MessageAdded,
  PaymentAdded,
  PaymentPaid,
  PaymentExpired,
  PaymentRefunded,
  PaymentDeficiencyAdjusted,
  PaymentExceedingAdjusted,
  PaymentWithdrawn,
  StatusUpdated,
  TenantProcessResultUpdated,
  PaymentPayeasyRequested,
  StatusReverted,
  RemovalTaskScheduled,
  RemovalTaskCanceled,
} from "@graffer-inc/cloud-gov-core";

export class ApplicationEventFactory {
  static createFromGql(
    result: ApplicationEventsQuery["applicationEventsAndMessages"]["events"][number],
  ): ApplicationEventType {
    return matchType(result.eventType, {
      Created: {
        ...result,
        eventType: "Created",
        data: result.data as Created["data"],
      },
      ContentModified: {
        ...result,
        eventType: "ContentModified",
        data: result.data as ContentModified["data"],
      },
      InternalCommentAdded: {
        ...result,
        eventType: "InternalCommentAdded",
        data: result.data as InternalCommentAdded["data"],
      },
      IssueFilesAdded: {
        ...result,
        eventType: "IssueFilesAdded",
        data: result.data as IssueFilesAdded["data"],
      },
      IssueFilesCancelled: {
        ...result,
        eventType: "IssueFilesCancelled",
        data: result.data as IssueFilesCancelled["data"],
      },
      IssueFilesFirstDownloaded: {
        ...result,
        eventType: "IssueFilesFirstDownloaded",
        data: result.data as IssueFilesFirstDownloaded["data"],
      },
      MessageAdded: {
        ...result,
        eventType: "MessageAdded",
        data: result.data as MessageAdded["data"],
      },
      PaymentAdded: {
        ...result,
        eventType: "PaymentAdded",
        data: result.data as PaymentAdded["data"],
      },
      PaymentPaid: {
        ...result,
        eventType: "PaymentPaid",
        data: result.data as PaymentPaid["data"],
      },
      PaymentExpired: {
        ...result,
        eventType: "PaymentExpired",
        data: result.data as PaymentExpired["data"],
      },
      PaymentPayeasyRequested: {
        ...result,
        eventType: "PaymentPayeasyRequested",
        data: result.data as PaymentPayeasyRequested["data"],
      },
      PaymentRefunded: {
        ...result,
        eventType: "PaymentRefunded",
        data: result.data as PaymentRefunded["data"],
      },
      PaymentDeficiencyAdjusted: {
        ...result,
        eventType: "PaymentDeficiencyAdjusted",
        data: result.data as PaymentDeficiencyAdjusted["data"],
      },
      PaymentExceedingAdjusted: {
        ...result,
        eventType: "PaymentExceedingAdjusted",
        data: result.data as PaymentExceedingAdjusted["data"],
      },
      PaymentWithdrawn: {
        ...result,
        eventType: "PaymentWithdrawn",
        data: result.data as PaymentWithdrawn["data"],
      },
      StatusUpdated: {
        ...result,
        eventType: "StatusUpdated",
        data: result.data as StatusUpdated["data"],
      },
      TenantProcessResultUpdated: {
        ...result,
        eventType: "TenantProcessResultUpdated",
        data: result.data as TenantProcessResultUpdated["data"],
      },
      StatusReverted: {
        ...result,
        eventType: "StatusReverted",
        data: result.data as StatusReverted["data"],
      },
      RemovalTaskScheduled: {
        ...result,
        eventType: "RemovalTaskScheduled",
        data: result.data as RemovalTaskScheduled["data"],
      },
      RemovalTaskCanceled: {
        ...result,
        eventType: "RemovalTaskCanceled",
        data: result.data as RemovalTaskCanceled["data"],
      },
    });
  }
}
